
import { Link } from "react-router-dom";
import AkkhorLayout from "../../layout/AkkhorLayout";
import List from "../../component/List";


export default function TagsSetting() {
  let params = '';
  const columns = [
    { name: "id", label: "ID", options: { filter: false, sort: true } },
    { name: "title", label: "Tags", options: { filter: true, sort: true } },
    { name: "alias", label: "Rút gọn", options: { filter: true, sort: true } },
    { name: "datecreate",label: "Ngày tạo",}
  ];
  
  return (<AkkhorLayout idrole="tags_settings">
    <div className="breadcrumbs-area">
            <ul>
                <li>
                    <Link to="/">Trang chủ</Link>
                </li>
                <li>
                    Cài đặt Tags
                </li>
            </ul>
        </div>
    <List name="tags_settings" idrole="tags_settings" params={params} title="" defaultLimit={50}  serverSide={true} columns={columns}></List>
    </AkkhorLayout>);
}
